<template>
  <div class="view box grow" style="overflow-y: auto;">
    <page-headers :header="'Rules'" :breadcrumbs="breadcrumbs" :is-border="true" documentation="page-rules" class="box">
      <!-- <div class="flex justify-flex-end page-actions" slot="actions">
        <span>
          <el-button type="text" class="icon-text-button">
            <i class="material-icons c-icon">open_in_new</i>
            <router-link to="/mitre-coverage">View MITRE Matrix</router-link>
          </el-button>
        </span>
      </div>-->
    </page-headers>
    <el-tabs v-model="activeView" @tab-click="changeView">
      <el-tab-pane label="Threat Progression" name="attack"></el-tab-pane>
      <el-tab-pane label="Privileged Activities" name="privileged"></el-tab-pane>
    </el-tabs>

    <router-view class="full-height"/>
  </div>
</template>

<script>
import PageHeaders from "@/components/layout/PageHeaders.vue";
import {Rules, PrivilegedRules} from "@/views/rules";

export default {
  name: "RuleView",
  data() {
    return {
      breadcrumbs: [{title: "Policy"}, {title: "Rules"}, {title: "Threat Progression"}],
      activeView: "attack",
      routePath: "/monitor/rules/attack",
      header: 'Threat Progression'
    };
  },
  beforeMount() {
    // If window refreshed, stay on previous rules page
    if (performance.navigation.type === 1) {
      this.$router.push(this.$route.path);
      this.activeView = this.$route.path.split("/").reverse()[0];
    } else {
      // set default path for attack progression rules
      this.$router.push(this.routePath);
    }
    if (this.activeView !== 'attack') {
      this.header = 'Privileged Progression'
      this.breadcrumbs = [{title: 'Policy'}, {title: 'Rules'}, {title: 'Privileged Progression'}]
      this.routePath = "/monitor/rules/privileged";
    }
  },
  methods: {
    changeView(tab, event) {
      if (tab.name === "attack") {
        this.header = 'Threat Progression'
        this.breadcrumbs = [{title: 'Policy'}, {title: 'Rules'}, {title: 'Threat Progression'}]
        this.routePath = "/monitor/rules/attack";
      } else {
        this.header = 'Privileged Progression'
        this.breadcrumbs = [{title: 'Policy'}, {title: 'Rules'}, {title: 'Privileged Progression'}]
        this.routePath = "/monitor/rules/privileged";
      }
      this.$router.push(this.routePath);
    }
  },
  components: {
    PageHeaders,
    Rules,
    PrivilegedRules
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }

    span {
      color: white;
      margin-bottom: 6px;
    }

    a {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rules/RuleView.vue